function handleBanner() {
  // IE11 polyfill for using classlist on SVG elements
  if (!Object.getOwnPropertyDescriptor(Element.prototype, 'classList')) {
    if (HTMLElement && Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'classList')) {
      Object.defineProperty(Element.prototype, 'classList', Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'classList'));
    }
  }

  const bannerContainers = Array.from(document.querySelectorAll('.qa__container'));
  const bannerAnswers = Array.from(document.querySelectorAll('.qa__answer'));
  const bannerArrows = Array.from(document.querySelectorAll('.qa__arrow'));

  bannerContainers.forEach((item, i) => {
    item.addEventListener('click', () => {
      bannerContainers[i].classList.toggle('qa__answer--visible');
      bannerAnswers[i].classList.toggle('qa__answer--visible');
      bannerArrows[i].classList.toggle('qa__answer--visible');
      bannerContainers[i].setAttribute('aria-expanded', !JSON.parse(bannerContainers[i].getAttribute('aria-expanded')));
      bannerAnswers[i].setAttribute('aria-hidden', !JSON.parse(bannerAnswers[i].getAttribute('aria-hidden')));
    }, false);
  });
}

export default handleBanner;
